import React from "react";

/**
 * CenterMessage — full-viewport centered state card with the MRKTNG
 * wordmark, a title, a sub-line, and an optional action. Used for empty
 * / no-access / "open a link" states.
 */
export function CenterMessage({ wordmark = "MENTIONS", title, sub, action }) {
  return (
    <main className='center-screen'>
      <section className='card'>
        <div className='wordmark'>{wordmark}</div>
        <h1>{title}</h1>
        {sub && <p className='sub'>{sub}</p>}
        {action}
      </section>
    </main>
  );
}
